// extracted by mini-css-extract-plugin
export default {"widgetGrid":"nzRFug2rIXEiDF23sLuh","widgetGridRow":"f7FyzMg3eVzmizX7r9Kg","widgetGridColumn":"TzMXm4QIOJZe2_xtFXta","welcomeText":"bFfJo0bdCTioy0V7tfQA"};